export class SscRawRequest {
    public module: string;
    public id: string;
    public function: string;
    public data: any;
    public jwt: string;
}
